import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntry} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const useGetCountrySelector = () => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getCountrySelector = async () => {
        const response = await getEntry({
            stack,
            contentTypeUid: 'country_selector',
            locale: locale.alias,
        })
        return response ? response[0] : null
    }

    const query = useQuery(['country_selector'], () => getCountrySelector())

    return query
}
